<div class="flex flex-col gap-2 bg-gray-900 text-white">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 p-4 lg:p-8">
    <!--col 1-->
    <div class="col-span-1 flex flex-col gap-4">
      <img
        src="/images/logo/tdusa-wordmark-white.png"
        alt="Site wordmark"
        class="h-4 md:h-6 lg:h-8 w-auto object-contain mr-auto"
      />
      <div>
        <div class="text-lg font-bold"><b>Call Us</b></div>
        <div>(501) 550-6758</div>
      </div>
      
      
      <div>
        <div>1017 Fayetteville Rd</div>
        <div>Van Buren AR 72956</div>
        <div>support@truckdriversus.com</div>
      </div>
      
      <div>
        <div>
          Rated Best Trucking Job Site 2025
          ⭐⭐⭐⭐⭐ 5/5</div>
          <div>Employers Choice Award 2025
          ⭐⭐⭐⭐⭐</div>
      </div>
    </div>

    <!--col 2-->
  <div class="col-span-1 flex flex-col gap-4">
    <div>
      <div class="text-lg font-bold"><b>Top Driver Types</b></div>
    <div>
    <a href="/browse-jobs/driver-type/company-driver/">Company Driver</a>
    </div>
    <div>
    <a href="/browse-jobs/driver-type/owner-operator/">Owner Operator</a>
    </div>
    <div>
    <a href="/browse-jobs/driver-type/lease-purchase/">Lease Purchase</a>
    </div>
    </div>
    <div>
      <div class="text-lg font-bold"><b>Top Freight Types</b></div>
    <div>
    <a href="/browse-jobs/freight-type/dry-van/">Dry Van</a>
    </div>
    <div>
    <a href="/browse-jobs/freight-type/flatbed/">Flatbed</a>
    </div>
    <div>
    <a href="/browse-jobs/freight-type/refrigerated-reefer/">Refridgerated</a>
    </div>
    </div>
  </div>

  <!--col 3-->
  <div class="col-span-1 flex flex-col">
    <div class="text-lg font-bold"><b>TDUSA</b></div>
    <div>
    <a href="https://truckdriversus.com/about/">About</a>
    </div>
    <div>
    <a href="https://truckdriversus.com/advertise/">Advertise</a>
    </div>
    <div>
    <a href="https://truckdriversus.com/contact/">Contact Us</a>
    </div>
  </div>

  <!--col 4-->
  <div class="col-span-1 flex flex-col">
    <div class="text-lg font-bold"><b>Learn More</b></div>
    <div><a href="https://mobileapp.careerdriver.ai">Career Driver AI</a></div>
    <div><a href="https://truckdriversus.com/truck-parking-club">Truck Parking</a></div>
    <div><a href="https://truckdriversus.com/driver-pay">Driver Pay Info</a></div>
    <div><a href="https://www.womenintrucking.org/" target="_blank">Women in Trucking</a></div>
  </div>
  </div>

  

  <div class="flex flex-row gap-2 p-2  text-xs md:text-sm border-t border-white/20">
    <!--left-->
  <div class="grow ">© {{currentYear()}} <a 
  class="font-semibold"
    href="https://truckdriversus.com" target="_blank">TRUCK DRIVERS USA</a> | All Rights Reserved. </div>
  
  <!--right-->
  <div class="flex flex-row gap-2 font-semibold">
  <a href="https://truckdriversus.com/privacy" target="_blank">Privacy</a>
  <div>|</div>
  <a href="https://truckdriversus.com/terms" target="_blank">Terms</a>
  </div>
  </div>
</div>
